import { type GetAppliedFiltersQuery } from '@/generated'
import {
  isAppliedAttributeFilter,
  isAppliedDateFilter,
  isAppliedDateRangeFilter,
  isAppliedRangeFilter,
} from '@/types/search'

/**
 * When a user clicks on "View Results" after applying filters, a GA event will be fired (FilterSelectAttempt)
 * containing string of all applied filters and their corresponding values as an event label.
 *
 * The string should be formatted as a single string with each filter delineated by a ",".
 * If a filter contains more than one value, the values should be sent in the form of an array.
 */
export const getAppliedFiltersGaLabel = (
  appliedFilters: GetAppliedFiltersQuery['searchResultsPageByUrl']['searchQuery']['filters']
) => {
  const normalizedAppliedFilters = appliedFilters.reduce((acc: string[], curr) => {
    const name = curr.filterName
    let value

    if (isAppliedAttributeFilter(curr)) {
      value = curr.values.length > 1 ? `[${curr.values.join(',')}]` : curr.values[0]
    } else if (isAppliedRangeFilter(curr)) {
      value = `[min=${curr.minValue}, max=${curr.maxValue}]`
    } else if (isAppliedDateRangeFilter(curr)) {
      value = `[min=${curr.start}, max=${curr.end}]`
    } else if (isAppliedDateFilter(curr)) {
      value = curr.value
    }

    return [...acc, `${name}=${value}`]
  }, [])

  //The filter/value array must then be returned as a semi colon separated string
  return normalizedAppliedFilters.join(';')
}
